var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group"},[_c('money',_vm._b({staticClass:"form-control",nativeOn:{"change":function($event){return _vm.changeAmount.apply(null, arguments)}},model:{value:(_vm.amount_copy),callback:function ($$v) {_vm.amount_copy=$$v},expression:"amount_copy"}},'money',_vm.money,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }